export const GET_VENDOR_SUPPORT_TICKETS_REQUEST =  "get_vendor_support_tickets_request";
export const GET_VENDOR_SUPPORT_TICKETS_SUCCESS =  "get_vendor_support_tickets_success";
export const GET_VENDOR_TICKET_STATUS_REQUEST =  "get_vendor_ticket_status_request";
export const GET_VENDOR_TICKET_STATUS_SUCCESS =  "get_vendor_ticket_status_success";
export const GET_VENDOR_TICKET_STORES_REQUEST =  "get_vendor_ticket_stores_request";
export const GET_VENDOR_TICKET_STORES_SUCCESS =  "get_vendor_ticket_stores_success";
export const GET_VENDOR_TICKET_CONVERSATION_REQUEST =  "get_vendor_ticket_conversation_request";
export const GET_VENDOR_TICKET_CONVERSATION_SUCCESS =  "get_vendor_ticket_conversation_success";

export const GET_VENDOR_TICKET_COMMENTS_REQUEST = "get_vendor_ticket_comments_request";
export const GET_VENDOR_TICKET_COMMENTS_SUCCESS = "get_vendor_ticket_comments_success";
export const SHARE_VENDOR_TICKET_REQUEST = "share_vendor_ticket_request";
export const SHARE_VENDOR_TICKET_SUCCESS = "share_vendor_ticket_success";
export const SHARE_VENDOR_TICKET_FAILURE = "share_vendor_ticket_failure";
export const UPDATE_VENDOR_TICKET_REQUEST = "update_vendor_ticket_request";
export const UPDATE_VENDOR_TICKET_SUCCESS = "update_vendor_ticket_success";
export const UPDATE_VENDOR_TICKET_FAILURE = "update_vendor_ticket_failure";
